import type { IResponseBase } from '@/interfaces';
import type { IBrokerSplitOverview, ICreateSubaccountsResponse } from '@/interfaces/ISetupSplit';
import type { FreezeState, IFrozenQueue, ISplitMe } from '@/interfaces/ISetupFreeze';
import type {
	IAdminWalletQuery,
	IWallet,
	IWalletAccess,
	IWalletPartnerOption,
} from '@/interfaces/ISetupWallet';
import { Http } from './http';

const http = Http.create();

export class SetupSplitService {
	/** Situação das subcontas dos corretores do parceiro e se ele está no piloto. */
	static async getBrokerOverview(brokerId: string) {
		const response = await http.get<IResponseBase<IBrokerSplitOverview>>(
			`/setup-split/brokers/${brokerId}`,
		);
		return response.data.data;
	}

	/** Cria no ASAAS a subconta de cada corretor do parceiro que ainda não tem. Só ADMIN. */
	static async createSubaccounts(brokerId: string) {
		const response = await http.post<IResponseBase<ICreateSubaccountsResponse>>(
			`/setup-split/brokers/${brokerId}/subaccounts`,
		);
		return response.data.data;
	}

	/** Se o usuário logado vê a Carteira: trabalha num parceiro do piloto. */
	static async getWalletAccess() {
		const response = await http.get<IResponseBase<IWalletAccess>>('/setup-split/wallet/access');
		return response.data.data;
	}

	/** Carteira do usuário logado. Datas yyyy-MM-dd em Brasília; sem datas, os últimos 12 meses. */
	static async getWallet(from?: string, to?: string) {
		const response = await http.get<IResponseBase<IWallet>>('/setup-split/wallet', {
			params: { from, to },
		});
		return response.data.data;
	}

	/** Carteira vista pelo ADMIN: a de um usuário ou a de um parceiro inteiro. Um dos dois é obrigatório. */
	static async getAdminWallet(query: IAdminWalletQuery) {
		const response = await http.get<IResponseBase<IWallet>>('/setup-split/wallet/admin', {
			params: query,
		});
		return response.data.data;
	}

	/** Parceiros do piloto e os usuários de cada um, para os filtros da Carteira do ADMIN. */
	static async getAdminWalletPartners() {
		const response = await http.get<IResponseBase<IWalletPartnerOption[]>>(
			'/setup-split/wallet/admin/partners',
		);
		return response.data.data;
	}

	/** Situação da subconta e congelado do usuário logado, para o alerta da Home. 404 fora do piloto. */
	static async getMe() {
		const response = await http.get<IResponseBase<ISplitMe>>('/setup-split/me');
		return response.data.data;
	}

	/** Fila do Financeiro: o setup congelado por falta de subconta, ordenado pelo prazo. */
	static async getFrozenQueue(state?: FreezeState) {
		const response = await http.get<IResponseBase<IFrozenQueue>>('/setup-split/frozen', {
			params: { state },
		});
		return response.data.data;
	}
}

export default SetupSplitService;
